import { render, staticRenderFns } from "./AnggotaUmumPengajuanRekomendasi.vue?vue&type=template&id=efefd776&"
import script from "./AnggotaUmumPengajuanRekomendasi.vue?vue&type=script&lang=js&"
export * from "./AnggotaUmumPengajuanRekomendasi.vue?vue&type=script&lang=js&"
import style0 from "./AnggotaUmumPengajuanRekomendasi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports